import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Application Components
import { SolicitudesComponent } from './solicitudes/solicitudes.component';
import { TramitesComponent } from './tramites/tramites.component';
import { PagarMandamientoComponent } from './pagar_mandamiento/pagar_mandamiento.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'solicitudes/:estado',
        component: SolicitudesComponent
      },
      {
        path: 'tramites/:estado',
        component: TramitesComponent
      },
      {
        path: 'pagar-mandamiento',
        component: PagarMandamientoComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
